import { axiosInstance } from '../utils/axios';

import { contentType, requestHeaders } from '../constants/requestHeaders';

export const getStreamWithUserData = (
  { path: { orgId, streamId } },
  extraData,
) =>
  Promise.all([
    axiosInstance.get(`/${orgId}/${streamId}`, {
      ...extraData,
      params: {
        refresh: Math.random(),
      },
    }),
    axiosInstance.get(`/${orgId}/${streamId}/userdata`, {
      ...extraData,
      params: {
        refresh: Math.random(),
      },
    }),
  ]);

export const getAllStreams = ({ params: { count, offset } }, extraData) =>
  axiosInstance.get(`/streams`, {
    ...extraData,
    params: {
      ...extraData?.params,
      refresh: Math.random(),
      count,
      offset,
    },
  });

export const postStream = (
  {
    path: { orgId },
    body: { id, name, description, properties, topics, locations },
    params: { isPrivate },
  },
  extraData,
) =>
  axiosInstance
    .post(
      `/${orgId}`,
      {
        id,
        name,
        topics,
        locations,
        description,
        properties,
      },
      {
        ...extraData,
        params: {
          private: isPrivate,
        },
      },
    )
    .then(() => getStreamWithUserData({ path: { orgId, streamId: id } }));

export const putStream = (
  {
    path: { orgId, streamId },
    body: { name, description, properties, topics, locations },
  },
  extraData,
) =>
  axiosInstance
    .put(
      `/${orgId}/${streamId}`,
      {
        name,
        topics,
        locations,
        description,
        properties,
      },
      extraData,
    )
    .then(() => getStreamWithUserData({ path: { orgId, streamId } }));

export const getStreamsList = ({ path: { orgId }, params }, extraData) =>
  axiosInstance.get(`${orgId}/streams?`, {
    ...extraData,
    params: {
      ...params,
      refresh: Math.random(),
    },
  });

export const getUserData = ({ path: { orgId, streamId } }, extraData) =>
  axiosInstance.get(`/${orgId}/${streamId}/userdata`, {
    ...extraData,
    params: {
      ...extraData?.params,
      refresh: Math.random(),
    },
  });

export const postStreamProfilePic = (
  { orgId, streamId, formData },
  extraData,
) =>
  axiosInstance.post(`/${orgId}/${streamId}/profile`, formData, {
    ...extraData,
    headers: requestHeaders.contentType(contentType.multipartFormData),
  });

export const postStreamCoverPic = ({ orgId, streamId, formData }, extraData) =>
  axiosInstance.post(`/${orgId}/${streamId}/cover`, formData, {
    ...extraData,
    headers: requestHeaders.contentType(contentType.multipartFormData),
  });
